module.exports = __webpack_public_path__ + "static/media/RajaRajeswari.447472b7.png";